module.exports = __webpack_public_path__ + "static/logoCerticatSmall-61b42548a500ee452337568554fd4749.png";